export default __webpack_public_path__ + "static/media/4706.380021aa.png";